import { render, staticRenderFns } from "./StudySetCreateDetail.vue?vue&type=template&id=c2f4c0d6&scoped=true&"
import script from "./StudySetCreateDetail.vue?vue&type=script&lang=js&"
export * from "./StudySetCreateDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudySetCreateDetail.vue?vue&type=style&index=0&id=c2f4c0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f4c0d6",
  null
  
)

export default component.exports